<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/sellerReports/">Reports</a></li>
      <li *ngIf="type == 'Order Detail'" class="breadcrumb-item active" aria-current="page">Order Detail</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <label class="mb-3" style="display: flex;"><span class="MobileContent"><i class="fa fa-arrow-left"
                                                                                    routerLink="/admin/sellerReports"></i></span>&nbsp;&nbsp;<b>{{type}}</b></label>
<!--
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label" for="sourceType">Source Type</label>
                <select class="form-control" id="sourceType" [(ngModel)]="sourceType"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="ALL">All</option>
                  <option value="MAGENTO">Magento</option>
                  <option value="AMAZON">Amazon</option>
                  <option value="SHOPCLUES">ShopClues</option>
                  <option value="FLIPKART">FlipKart</option>
                  <option value="SHOPIFY">Shopify</option>
                  <option value="EBAY">Ebay</option>
                  <option value="WOOCOMMERCE">WooCommerce</option>
                  <option value="SHIFT">Shift</option>
                </select>
              </div>
            </div>
          </div>
-->

          <div class="row">
            <div class="col-md-3">
              <div class="form-group required">
                <label class="control-label" for="fromDate">Start Date</label>
                <input type="date" id="fromDate" [(ngModel)]="startDate"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!startDateError">
                  {{startDateError}}
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group required">
                <label class="control-label" for="toDate">End Date</label>
                <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!endDateError">{{endDateError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6" style="padding-left: 30px;">
              <button type="button" routerLink="/admin/sellerReports" class="btn btn-cancel deskContent">Back</button>
            </div>
            <div class="col-md-6 text-right" style="padding-right: 30px;">
              <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
              <button type="submit" (click)="submitOrder()" class="btn btn-orange ml-2">Generate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="type =='Order Detail'">
      <div class="col-12" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
              <a placement="bottom" class="mr-2" ngbTooltip="Export To Pdf" *ngIf="orderList?.length">
                <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                     (click)="exportToPdf()" width="30" height="30">
                  <defs>
                    <image width="30" height="30" id="img1"
                           href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                  </defs>
                  <style>tspan { white-space:pre }

                  </style>
                  <use id="Background" href="#img1" x="0" y="0"/>
                </svg>
              </a>
              <a placement="bottom" ngbTooltip="Export To Excel" *ngIf="orderList?.length"
                 style="text-align-last: center;">
                <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                     viewBox="0 0 30 30">
                  <defs>
                    <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                  </defs>
                  <g transform="translate(4 2.5)">
                    <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                    <path class="b"
                          d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                          transform="translate(3.386 5.171)"/>
                  </g>
                </svg>
              </a>
              <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
                 <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
                 &lt;!&ndash;
                       <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
                 &ndash;&gt;
               </div>-->
            </div>
          </div>
          <div style="overflow: auto;">
            <table class="table">
              <tr>
                <th>Order#</th>
                <th>Customer Name</th>
                <th>Created Date</th>
                <th>Order Type</th>
                <th>Channel Name</th>
                <th>Status</th>
              </tr>
              <tr *ngFor="let od of orderList">
                <td>{{od.orderNumber}}</td>
                <td>{{od.ownerName}}</td>
                <td>{{od.createdDate}}</td>
                <td>{{od.orderType}}</td>
                <td>{{od.channelName | titlecase}}</td>
                <td>{{(od.orderStatus == 'SUBMITTED' ? 'Submitted' : (od.orderStatus == 'READY_TO_PICK' ? 'Ready To
                  Pick'
                  : (od.orderStatus == 'PACKER_ASSIGNED' ? 'Packer Assigned' : (od.orderStatus == 'READY_TO_SHIP' ?
                  'Ready
                  To Ship' : (od.orderStatus == 'COMPLETED' ? 'Completed' : (od.orderStatus == 'AWAITING_CARRIER' ?
                  'Awaiting Carrier' : (od.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : (od.orderStatus ==
                  'TO_PACK' ? 'To Pack' : (od.orderStatus == 'DELIVERED' ? 'Delivered' : (od.orderStatus ==
                  'GENERATE_LABEL' ? 'Generate Label' : (od.orderStatus == 'CANCELLED' ? 'Cancelled' : (od.orderStatus
                  ==
                  'EXCEPTION' ? 'Exception' : (od.orderStatus == 'ON_HOLD' ? 'On Hold' : (od.orderStatus == 'SPLITTED' ?
                  'Splitted' : (od.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted' : (od.orderStatus ==
                  'PARTIALLY_RETURN' ? 'Partially Returned' : (od.orderStatus ==
                  'TO_PICK' ? 'To Pick' : (od.orderStatus == 'RETURN' ? 'Returned' : (od.orderStatus == 'DRAFT' ?
                  'Draft'
                  : (od.orderStatus == 'PRODUCT_PACKED' ? 'Product Packed' : (od.orderStatus == 'PICK_ASSIGNED' ? 'Pick
                  Assigned' : od.orderStatus )))))))))))))))))))))}}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>
  </form>
</section>
